import { render, staticRenderFns } from "./tile.vue?vue&type=template&id=4fd374f8&"
import script from "./tile.vue?vue&type=script&lang=js&"
export * from "./tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports